// extracted by mini-css-extract-plugin
export var navbarSubLink = "H_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "H_vR d_f0 d_dB";
export var subPageLink = "H_gf d_gf";
export var burger = "H_vV";
export var sublinkSize = "H_vW";
export var linkSize = "H_vX";
export var Link = "H_tx y_tx y_sL y_s4";